export const twoStepAuthenticationDisableStyles = {
	title: {
		fontSize: '24px',
		fontWeight: '700',
		textAlign: 'center',
		whiteSpace: 'nowrap',
		marginTop: '32px',
		marginBottom: '8px',
	},
	description: {
		paddingTop: '8px',
		textAlign: 'center',
		fontSize: '16px',
		lineHeight: '24px',
		marginBottom: '20px',
	},
	buttonWrapper: {
		display: 'flex',
		justifyContent: 'space-evenly',
		gap: '24px',
		marginTop: '32px',
	},

	icon: {
		display: 'flex',
		margin: '0 auto',
		height: '60px',
		width: '60px',
	},
	iconChecked: {
		display: 'flex',
		margin: '0 auto',
		height: '60px',
		width: '60px',
		'& svg': {
			fill: 'var(--primary-500)',
			height: '60px',
			width: '60px',
		},
	},
};
